export enum OptionType {
    CHECK_LIST, TEXT, TYPE_TEXT, TYPE, DATE
}